import { Component, HostBinding, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import {highestWidthSrcsetSrc, Photo, srcsetToHtmlString} from '../../models/photo';
import {ProjectReferencePhotoService} from '../../services/project-reference-photo.service';
import {SafeValue} from '@angular/platform-browser';
import {ProjectReferenceSearchResponseImage} from '../../models/project-reference-search-response';
import {ProjectReferencePhoto} from '../../models/project-reference-photo';

@Component({
    selector: 'app-photo',
    templateUrl: './photo.component.html',
    standalone: false
})
export class PhotoComponent implements OnChanges {
    private photoReferenceService = inject<ProjectReferencePhotoService>('ProjectReferencePhotoService' as any);

    @HostBinding('class') classNames = 'block overflow-hidden';
    @Input() photo?: Photo | ProjectReferenceSearchResponseImage | ProjectReferencePhoto | null | undefined;
    @Input() alt = '';
    @Input() sizes: string | undefined = undefined; // default 100vw

    src: string|SafeValue|undefined = undefined;
    srcset: string|SafeValue|undefined = undefined;

    async ngOnChanges(changes: SimpleChanges) {
        if ((this.photo as any)?.srcset !== 'undefined') {
            const srcset = ((this.photo as Photo)?.srcset || {});

            this.srcset = srcsetToHtmlString(srcset);
            this.src = highestWidthSrcsetSrc(srcset) || this.photo?.originalUrl || undefined;
        } else if (this.photo) {
            this.src = this.photo.originalUrl || undefined;
            this.srcset = undefined;
        } else {
            console.warn('Unable to load src for photo', this.photo);

            this.src = undefined;
        }
    }
}
